import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Ruiz from '../../img/agenda/Ruiz.png'
import jfrog from '../../img/agenda/jfrog.png'
import Assouline from '../../img/agenda/Assouline.png'
import Google from '../../img/agenda/Google.png'
import Freiberg from '../../img/agenda/Freiberg.png'
import Ivaniuk from '../../img/agenda/Ivaniuk.png'
import aws from '../../img/agenda/aws.png'

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    time: '09:00',
                    photo: Ruiz,
                    name: 'Ixchel Ruiz',
                    position: 'DA - Senior Software Developer',
                    tw: 'https://twitter.com/ixchelruiz',
                    logo: jfrog,
                    title: 'DevOps for Java Developers: Are we there yet?',
                    abstract: `In recent years, how we approach development has dramatically changed with the rise of DevOps, Cloud Computing, and Container technologies. Many stakeholders at our organizations are ecstatic about Shift Left, DevSecOps, and VSM, but how are we as Java developers embracing this new cultural shift? 
                    In this session, we will explore the most common Critical Challenges to Adopt DevOps Culture in Software Organizations, best practices, and some excellent news with success stories.        
                    You'll get: Tools and Culture *Challenges* and hopefully tips.`,
                },
                {
                    time: '09:45',
                    photo: Assouline,
                    name: 'Jordan Assouline',
                    position: 'Customer Engineer Application Modernization @Google',
                    ln: 'https://www.linkedin.com/in/jordan-assouline-5b4aa17a/',
                    logo: Google,
                    title: 'DevSecOps - Security tools integration into your pipelines',
                    abstract: `Does DevSecOps seem complicated to you?
                    With this talk, you will see that it is simple to use the power of many free tools, within your pipelines.
                    Learn how to scan your Docker images, your containers, your Kubernetes clusters, your code, the libraries you use, the OS that host your services, etc...
                    Live Demo of a secure Docker image build pipeline`,
                },
                {
                    time: '10:30',
                    photo: Freiberg,
                    name: 'Ben Freiberg',
                    position: 'Senior Solutions Architect',
                    ln: 'http://www.linkedin.com/in/benfreiberg',
                    logo: aws,
                    title: 'Build Serverless workflows with AWS Step Functions',
                    abstract: `Do you wonder how to orchestrate the components of a distributed application? Do you want to automate your workflows without writing code? AWS Step Functions makes these tasks simpler, faster, and more intuitive. This session covers the features that can enable you to do more with less code. We will take a closer look at how to use AWS Step Functions to manage distributed data transactions in Microservices using the Saga Orchestration pattern.        

                    You'll get: Better understanding of the architecture patterns and solutions you can build with AWS Step Functions such as application orchestration, data processing, task automation, and data science workflows.`,
                },
                {
                    time: '11:15',
                    photo: Ivaniuk,
                    name: 'Igor Ivaniuk',
                    position: 'Sr. Solutions Architect',
                    tw: 'https://twitter.com/I_Ivaniuk',
                    logo: aws,
                    title: 'Scale your Kubernetes cluster smarter with Karpenter',
                    abstract: `The cloud is all about elasticity and right-sizing. Microservice architectures are keen to be implemented in containers, and Kubernetes is arguably the most common orchestrator to run them. These containers, being (usually) stateless, are good candidates to use the cloud elasticity, so scaling them should be a well-known task. 
                    We'll talk about different scaling approaches and focus on Karpenter - the new group less cluster autoscaler, that can dramatically improve the efficiency and cost of running workloads on your cluster.
                    
                    You'll learn more about Kubernetes autoscaling, Karpenter features that allow right-sized scaling of EKS clusters`,
                },
            ],
        }
    }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h2 className="agenda_title">Agenda</h2>
                    <p className="agenda_undertitle">Time zone 0 UTC</p>
                    <p className="agenda_undertitle">October 4 09:00 - 20:00</p>
                    <p className="agenda_day">Day 1: Beginners</p>
                    <VideoPresent speakers={this.state.list} />
                    <a className='button agenda_full_btn' href='https://geekle.us/schedule/devops22' target='_blank' rel="noreferrer">SHOW MORE</a>
                </div>
            </div>
        );
    }
};